import React from 'react';
import { QuestionProps } from '../Quiz/Quiz';
import './MultiAnswer.scss';

const MultiAnswer: React.FC<QuestionProps> = ({ question, answers, notes, nextSlide, onAnswerSelect }) => {
  const readyToGo = answers[question.id] && Object.keys(answers[question.id]).length > 0;

  return (
    <div className={'ma-slide'}>
      <h2>{question.question}</h2>
      <p className={'instructions'}>SELECT ALL THAT APPLY:</p>
      <div className={'answers-wrapper'}>
        {question.answers.map((answer) => {
          const value: boolean = !!answers[question.id]?.[answer.id];
          return (
            <div
              key={`item-${question.id}-${answer.id}`}
              className={`answer ${value ? 'selected' : ''}`}
              onClick={() => onAnswerSelect(question.id, answer.id, true)}
            >
              <div className={'answer-content'}>{answer.answer}</div>
            </div>
          );
        })}
      </div>
      <p>{readyToGo ? notes : '\u00A0'}</p>
      <button className={'next'} disabled={readyToGo ? false : true} onClick={nextSlide}>
        Next &gt;
      </button>
    </div>
  );
};

export default MultiAnswer;
